import { render, staticRenderFns } from "./NeedsActionSubmission.vue?vue&type=template&id=0f2407f8&scoped=true"
import script from "./NeedsActionSubmission.vue?vue&type=script&lang=js"
export * from "./NeedsActionSubmission.vue?vue&type=script&lang=js"
import style0 from "./NeedsActionSubmission.vue?vue&type=style&index=0&id=0f2407f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2407f8",
  null
  
)

export default component.exports